import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { JSX, Ref } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface TextareaInputFieldProps extends Omit<FormFieldComponentProps, "ref"> {
  formItemClassName?: string;
  ref?: Ref<HTMLTextAreaElement>;
};

const TextareaInputField = (props: TextareaInputFieldProps): JSX.Element => {
  const { form, name, label, className, showOptional, isFormItem = true, placeholder, formItemClassName, ref, disabled } = props;

  const { t } = useTranslation(["common"]);

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(isFormItem && "form-item", formItemClassName)}>
          {label &&
            <FormLabel>{label}
              {showOptional &&
                <span className="text-slate-400 font-normal">&nbsp;({t("optional")})</span>
              }
            </FormLabel>
          }
          <FormControl>
            <Textarea placeholder={placeholder ?? label} className={cn("resize-none", className)} {...field} ref={ref} disabled={disabled} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default TextareaInputField;
